<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-container fluid class="subheading font-weight-bold" v-if="shouldDisplayHeading()">
        <!-- Heading -->
        <div>{{$t('rms_applied_filters_label')}}</div>
        <!-- Availibility filters -->
        <div class="mt-3">
          <span class="availibility_filters">
            <span v-if="!empty(filters.rights)">
              <v-chip
                small
                close
                @input="doRemoveFilters('rights', right.id)"
                v-for="right in getTags(
              filters.rights,
              DEFINES.TAG_TYPE.FOR_RIGHTS,
            )"
                :key="right.id"
              >
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_rights')
                  }}
                </v-avatar>
                <span>{{ right.name }}</span>
              </v-chip>
            </span>

            <span v-if="!empty(filters.countries)">
              <v-chip
                close
                small
                @input="doRemoveFilters('countries', country.id)"
                v-for="country in getTags(
              filters.countries,
              DEFINES.TAG_TYPE.FOR_FILM_COUNTRIES,
            )"
                :key="country.id"
              >
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_countries')
                  }}
                </v-avatar>
                <span>{{ country.name }}</span>
              </v-chip>
            </span>
          </span>

          <!-- Search filters -->
          <span class="search_filters" v-if="isAllowedSearchFilters()">
            <span v-if="!empty(filters.genres)">
              <v-chip
                close
                small
                @input="doRemoveFilters('genres', genre.id)"
                v-for="genre in getTags(
              filters.genres,
              DEFINES.TAG_TYPE.FOR_FILM_GENRE,
            )"
                :key="genre.id"
              >
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_genres')
                  }}
                </v-avatar>
                <span>{{ genre.name }}</span>
              </v-chip>
            </span>

            <span v-if="!empty(filters.types)">
              <v-chip
                close
                small
                @input="doRemoveFilters('types', type.id)"
                v-for="type in getTags(
              filters.types,
              DEFINES.TAG_TYPE.FOR_FILM_TYPE,
            )"
                :key="type.id"
              >
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_type')
                  }}
                </v-avatar>
                <span>{{ type.name }}</span>
              </v-chip>
            </span>

            <span v-if="!empty(filters.formats)">
              <v-chip
                close
                small
                @input="doRemoveFilters('formats', format.id)"
                v-for="format in getTags(
              filters.formats,
              DEFINES.TAG_TYPE.FOR_FILM_FORMAT,
            )"
                :key="format.id"
              >
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_format')
                  }}
                </v-avatar>
                <span>{{ format.name }}</span>
              </v-chip>
            </span>

            <span v-if="filters.exclusive !== null">
              <v-chip close small @input="doRemoveFilters('exclusive')">
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_contract')
                  }}
                </v-avatar>
                <span>
                  {{
                  getTagName(filters.exclusive, DEFINES.TAG_TYPE.FILM_CONTRACT_TYPE)
                  }}
                </span>
              </v-chip>
            </span>

            <span v-if="filters.release_year !== null">
              <v-chip close small @input="doRemoveFilters('release_year')">
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_release_years')
                  }}
                </v-avatar>
                <span>
                  {{
                  getTagName(
                  filters.release_year,
                  DEFINES.TAG_TYPE.FILM_RELEASE_YEAR,
                  )
                  }}
                </span>
              </v-chip>
            </span>

            <span v-if="filters.title">
              <v-chip close small @input="doRemoveFilters('title')">
                <v-avatar class="orange darken-2">
                  {{
                  $t('rms_chip_label_for_title')
                  }}
                </v-avatar>
                <span>{{ filters.title }}</span>
              </v-chip>
            </span>
          </span>
        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  name: "AppliedFilters",
  data() {
    return {
      hello: true
    };
  },
  props: ["filters"],
  computed: {
    ...mapState({
      drawer: state => state.app.toolbar.drawer,
      session_mode: state => state.app.session_mode
    }),
    ...mapGetters({
      is_filters_applied: "filter/is_applied",
      applied_filters: "filter/getApplied",
      availLink: "availLink/get",
      is_rights_or_countries_applied: "filter/isRightsOrCountriesApplied"
    })
  },
  methods: {
    empty(item) {
      return !item || !item.length ? true : false;
    },
    getTags(tags, type) {
      var tags = this.$store.getters["tag/getTagsfromIds"](tags, type);
      return tags;
    },
    getTagName(tag_id, tag_type) {
      var tag = this.$store.getters["tag/getTag"](tag_id, tag_type);
      return tag.name;
    },
    openDrawer() {
      this.$store.commit("app/openDrawer");
    },
    async doRemoveFilters(label, id = null) {
      await this.$store.commit("filter/removeApplied", {
        label,
        id
      });
      this.is_filters_applied
        ? this.getFilteredResult()
        : this.$store.dispatch("film/list");
    },
    async getFilteredResult() {
      await this.$store.dispatch("filter/listFilms", this.applied_filters);
    },

    isAllowedSearchFilters() {
      // If session is in avail mode then check refine search is allow or not
      if (
        this.session_mode == this.DEFINES.AVAIL_SESSION_MODE &&
        !this.availLink.is_search_filters_allowed
      ) {
        return false;
      }
      return true;
    },

    shouldDisplayHeading() {
      if (
        this.session_mode == this.DEFINES.AVAIL_SESSION_MODE &&
        !this.availLink.is_search_filters_allowed &&
        !this.is_rights_or_countries_applied
      ) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style scoped></style>
